module.exports = __webpack_public_path__ + "img/34.9b776cc8.jpg";